let count;

if (window.matchMedia('(max-width: 767px)').matches) {
  let count = 2;
} else if (window.matchMedia('(min-width:768px)').matches) {
  let count = 3;
}

////////////////// 慣性スクロール
if (window.matchMedia('(max-width: 767px)').matches) {
  //スマホ処理
  console.log("スマホだよ")
} else if (window.matchMedia('(min-width:768px)').matches) {
  const lenis = new Lenis({
    duration: 1.2, // アニメーションの継続時間
    direction: 'vertical', // 方向
    gestureDirection: 'vertical',
    smooth: true, // スムーススクロールの有効・無効を設定
    smoothTouch: false, // タッチスクロール時のスムーススクロールの有効・無効を設定。(タッチデバイス本来の滑らかさを模倣することは不可能であるため、デフォルト無効)
    touchMultiplier: 2,
  })
  function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
  }
  requestAnimationFrame(raf)
}


////////////////// スクロール

const list = document.querySelectorAll(".fade")
list.forEach(function(element, i) {
  gsap.fromTo(
    list[i], // アニメーションさせる要素
    {opacity: 0,y: 30,},
    {
      opacity: 1,y: 0,duration: 0.3,
      scrollTrigger: {
        trigger: list[i],
        toggleActions: "play none none none", 
        start: "top-=200 center", 
        // markers: true,
      },
    }
  );
});


//////////////////// KV：写真がふわっと出てから、ロゴが左から右へ出る
// （vol.01〜05 の写真は transform で中央寄せしているので、transform ではなく margin-top で動かす）
const kvImgs = document.querySelectorAll(".ccg_top_wrapper .guide_top_kv");
const kvLogos = document.querySelectorAll(".ccg_top_wrapper .guide_logo_pc, .ccg_top_wrapper .guide_logo_sp");
if (kvImgs.length) {
  const kvLoaded = [...kvImgs].map((img) =>
    img.complete ? Promise.resolve() : new Promise((resolve) => {
      img.addEventListener("load", resolve, { once: true });
      img.addEventListener("error", resolve, { once: true });
    })
  );
  // 読み込みが遅くても 2 秒で開始
  Promise.race([Promise.all(kvLoaded), new Promise((resolve) => setTimeout(resolve, 2000))]).then(() => {
    const tl = gsap.timeline({ delay: 0.2 });
    kvImgs.forEach((img) => {
      // transform で中央寄せしている写真は margin-top、それ以外（vol.06）は y で少し下から
      const centered = getComputedStyle(img).transform !== "none";
      const from = centered ? { opacity: 0, marginTop: 30 } : { opacity: 0, y: 30 };
      const to = centered
        ? { opacity: 1, marginTop: 0, duration: 1.2, ease: "power2.out", clearProps: "marginTop" }
        : { opacity: 1, y: 0, duration: 1.2, ease: "power2.out", clearProps: "transform" };
      tl.fromTo(img, from, to, 0);
    });
    tl.fromTo(kvLogos, { clipPath: "inset(0% 100% 0% 0%)" }, { clipPath: "inset(0% 0% 0% 0%)", duration: 1, ease: "power2.inOut" }, "-=0.2");
  });
}

//////////////////// タイトル（vol.0X の見出し画像）：スクロール位置で左から右へ出る
// 画像の読み込み前はページが短く、画面内と判定されてすぐ再生されてしまうので load 後に作る
window.addEventListener("load", () => document.querySelectorAll(".ccg_vol .ccg_vol_02").forEach((title) => {
  gsap.fromTo(title,
    { clipPath: "inset(0% 100% 0% 0%)" },
    {
      clipPath: "inset(0% 0% 0% 0%)",
      duration: 1.2,
      ease: "power2.inOut",
      scrollTrigger: {
        trigger: title,
        start: "top 80%",
        toggleActions: "play none none none",
      },
    }
  );
}));

//////////////////// 横長写真：枠のサイズはそのまま、中の写真が拡大した状態から縮んで等倍になる
document.querySelectorAll(".guide_article_yokonaga").forEach((box) => {
  const img = box.querySelector("img");
  if (!img) return;
  gsap.fromTo(img,
    { scale: 1.3 },
    {
      scale: 1,
      ease: "none",
      scrollTrigger: {
        trigger: box,
        start: "top bottom",
        end: "center center",
        scrub: 1,
      },
    }
  );
});


//////////////////// 車（1台目 / article3・article4のCASE A）
const carH3List = document.querySelectorAll(".ccg_about .car_h3");
const carSection1 = carH3List[0] ? carH3List[0].closest(".ccg_about") : null;
if (carSection1) {
  const car1 = carSection1.querySelector(".ccg_car_car");
  const desc1 = carSection1.querySelectorAll(".ccg_car_desc01, .ccg_car_desc02, .ccg_car_desc03");
  if (car1) {
    gsap.timeline({
      scrollTrigger: {
        trigger: carH3List[0],
        scrub: 1,
        start: "center center",
        toggleActions: "play none none none",
        end: "+=100",
      }
    }).fromTo(car1, {opacity: 0, scale: 0}, {opacity: 1, scale: 1})
      .fromTo(desc1, {opacity: 0, scale: 0}, {opacity: 1, scale: 1}, "+=0.8");
  }
}

//////////////////// 車2（article4のCASE B用・2番目の.ccg_about内のみアニメーション）
const carSection2 = carH3List[1] ? carH3List[1].closest(".ccg_about") : null;
if (carSection2) {
  const car2 = carSection2.querySelector(".ccg_car_car2");
  const desc2 = carSection2.querySelectorAll(".ccg_car_desc01, .ccg_car_desc02, .ccg_car_desc03");
  if (car2) {
    gsap.timeline({
      scrollTrigger: {
        trigger: carH3List[1],
        scrub: 1,
        start: "center center",
        toggleActions: "play none none none",
        end: "+=100",
      }
    }).fromTo(car2, {opacity: 0, scale: 0}, {opacity: 1, scale: 1})
      .fromTo(desc2, {opacity: 0, scale: 0}, {opacity: 1, scale: 1}, "+=0.8");
  }
}

//////////////////// 車3（article4のCASE C用・3番目の.ccg_about内のみアニメーション）
const carSection3 = carH3List[2] ? carH3List[2].closest(".ccg_about") : null;
if (carSection3) {
  const car3 = carSection3.querySelector(".ccg_car_car3");
  const desc3 = carSection3.querySelectorAll(".ccg_car_desc01, .ccg_car_desc02, .ccg_car_desc03");
  if (car3) {
    gsap.timeline({
      scrollTrigger: {
        trigger: carH3List[2],
        scrub: 1,
        start: "center center",
        toggleActions: "play none none none",
        end: "+=100",
      }
    }).fromTo(car3, {opacity: 0, scale: 0}, {opacity: 1, scale: 1})
      .fromTo(desc3, {opacity: 0, scale: 0}, {opacity: 1, scale: 1}, "+=0.8");
  }
}



//////////////////// text
const list_text_all = document.querySelectorAll(".TextAnim")
list_text_all.forEach(function(element, i) {
  // class付きの<br>（例：<br class="sp-only">）は残す。ただし末尾の<br>は従来通り除去
  let html = "";
  const nodes = Array.from(list_text_all[i].childNodes);
  nodes.forEach(function(node, n) {
    const hasTextAfter = nodes.slice(n + 1).some(function(next) { return next.textContent.trim() !== ""; });
    if (node.nodeName === "BR" && node.className && hasTextAfter) {
      html += node.outerHTML;
    } else {
      html += node.textContent.replace(/\S/g, "<span class='letter" + i + "'>$&</span>");
    }
  });
  list_text_all[i].innerHTML = html;
  let letter = document.querySelectorAll(".letter" + i);
  gsap.fromTo(
    letter, // アニメーションさせる要素
    {opacity: 0,y: 10,},
    {
      opacity: 1,y: 0,duration: 0.6,
      scrollTrigger: {
        trigger: list_text_all[i],
        toggleActions: "play none none none", 
        start: "top-=200 center", 
        // markers: true,
      },
      stagger: {
        each: .01, // 遅延させる時間
      }
    }
  );
});



// vol.06 は道路の位置がセクションごとに違うので、下の固定距離のアニメーションは使わず
// 末尾の「車_vol.06」で道路の実際の位置から経路を作る
const isArticle6 = window.location.pathname.indexOf("/blogs/ccg_article6") !== -1;

if (!isArticle6) {
  //////////////////// 車_pc
  const car_all = document.querySelectorAll(".car_car");
  const isArticle4 = window.location.pathname.indexOf("/blogs/ccg_article4") !== -1;

  car_all.forEach(function(element, i) {
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: car_all[i],
        scrub: 1,
        start: "center-300 center",
        end: isArticle4 ? "+=2800" : "+=1500",
        // markers: true,
      }
    });

    tl.to(car_all[i], { x: "+=970" })
      .to(car_all[i], { rotate: "+=90", y: "+=150", duration: 0.1 }, "-=0.12")
      .to(car_all[i], { y: "+=520" })
      .to(car_all[i], { rotate: "+=90", x: "-=100", duration: 0.15 }, "-=0.1")
      .to(car_all[i], { x: "-=960" })
      .to(car_all[i], { rotate: "-=90", y: "+=80", duration: 0.1 }, "-=0.1")
      .to(car_all[i], { y: "+=310" })
      .to(car_all[i], { rotate: "-=90", x: "+=50", duration: 0.1 }, "-=0.1")
      .to(car_all[i], { x: "+=1020" })
      .to(car_all[i], { rotate: "+=90", y: "+=150", duration: 0.2 }, "-=0.12")
      .to(car_all[i], { y: "+=420" });

    if (isArticle4) {
      tl.to(car_all[i], { rotate: "+=90", x: "-=90", y: "+=90", duration: 0.15 }, "-=0.05")
        .to(car_all[i], { x: "-=1100" })
        .to(car_all[i], { rotate: "-=90", x: "+=90", y: "+=90", duration: 0.15 }, "-=0.05")
        .to(car_all[i], { y: "+=720" });
    }

    tl.to(car_all[i], { opacity: "0", duration: 0.1 }, "-=0.1");
  });


  //////////////////// 車_sp_1
  const car_all_sp_1 = document.querySelector(".car_car_sp_1")
  if (isArticle4) {
    gsap.timeline({
      scrollTrigger: {
        trigger: car_all_sp_1,
        scrub: 1,
        start: "center center",
        end: "+=1800",
        // markers: true,
      }
    }).to(car_all_sp_1, {
      y: "+=600",
    }).to(car_all_sp_1, {
      rotate: "-=90",
      x: "+=30",
      duration: 0.1
    },"-=0.01").to(car_all_sp_1, {
      x: "+=290",
    }).to(car_all_sp_1, {
      rotate: "+=90",
      y: "+=30",
      duration: 0.1
    },"-=0.01").to(car_all_sp_1, {
      y: "+=520",
    }).to(car_all_sp_1, {
      rotate: "+=90",
      x: "-=60",
      duration: 0.1
    },"-=0.01").to(car_all_sp_1, {
      x: "-=260",
    }).to(car_all_sp_1, {
      rotate: "-=90",
      y: "+=60",
      duration: 0.1
    }).to(car_all_sp_1, {
      y: "+=450",
    }).to(car_all_sp_1, {
      y: "-=50",
    }).to(car_all_sp_1, {
      y: "+=750",
    }).to(car_all_sp_1, {
      opacity: "0",
      duration: 0.1,
    },"-=0.1")
  } else {
    gsap.timeline({
      scrollTrigger: {
        trigger: car_all_sp_1,
        scrub: 1,
        start: "center center",
        end: "+=1800",
        // markers: true,
      }
    }).to(car_all_sp_1, {
      y: "+=600",
    }).to(car_all_sp_1, {
      rotate: "-=90",
      x: "+=30",
      duration: 0.1
    },"-=0.01").to(car_all_sp_1, {
      x: "+=290",
    }).to(car_all_sp_1, {
      rotate: "+=90",
      y: "+=30",
      duration: 0.1
    },"-=0.01").to(car_all_sp_1, {
      y: "+=520",
    }).to(car_all_sp_1, {
      rotate: "+=90",
      x: "-=60",
      duration: 0.1
    },"-=0.01").to(car_all_sp_1, {
      x: "-=260",
    }).to(car_all_sp_1, {
      rotate: "-=90",
      y: "+=60",
      duration: 0.1
    }).to(car_all_sp_1, {
      y: "+=550",
    }).to(car_all_sp_1, {
      opacity: "0",
      duration: 0.1,
    },"-=0.1")
  }


  //////////////////// 車_sp_2
  const car_all_sp_2 = document.querySelector(".car_car_sp_2")
  if (isArticle4) {
    gsap.timeline({
      scrollTrigger: {
        trigger: car_all_sp_2,
        scrub: 1,
        start: "center center",
        end: "+=2200",
        // markers: true,
      }
    }).to(car_all_sp_2, {
      y: "+=590",
    }).to(car_all_sp_2, {
      rotate: "-=90",
      x: "+=30",
      duration: 0.1
    },"-=0.01").to(car_all_sp_2, {
      x: "+=290",
    }).to(car_all_sp_2, {
      rotate: "+=90",
      y: "+=30",
      duration: 0.1
    },"-=0.01").to(car_all_sp_2, {
      y: "+=530",
    }).to(car_all_sp_2, {
      rotate: "+=90",
      x: "-=60",
      duration: 0.1
    },"-=0.01").to(car_all_sp_2, {
      x: "-=260",
    }).to(car_all_sp_2, {
      rotate: "-=90",
      y: "+=60",
      duration: 0.1
    }).to(car_all_sp_2, {
      y: "+=1400",
    }).to(car_all_sp_2, {
      opacity: "0",
      duration: 0.1,
    },"-=0.1")
  } else {
    gsap.timeline({
      scrollTrigger: {
        trigger: car_all_sp_2,
        scrub: 1,
        start: "center center",
        end: "+=2200",
        // markers: true,
      }
    }).to(car_all_sp_2, {
      y: "+=880",
    }).to(car_all_sp_2, {
      rotate: "-=90",
      x: "+=30",
      duration: 0.1
    },"-=0.01").to(car_all_sp_2, {
      x: "+=290",
    }).to(car_all_sp_2, {
      rotate: "+=90",
      y: "+=30",
      duration: 0.1
    },"-=0.01").to(car_all_sp_2, {
      y: "+=520",
    }).to(car_all_sp_2, {
      rotate: "+=90",
      x: "-=60",
      duration: 0.1
    },"-=0.01").to(car_all_sp_2, {
      x: "-=260",
    }).to(car_all_sp_2, {
      rotate: "-=90",
      y: "+=60",
      duration: 0.1
    }).to(car_all_sp_2, {
      y: "+=900",
    }).to(car_all_sp_2, {
      opacity: "0",
      duration: 0.1,
    },"-=0.1") 
  }


  //////////////////// 車_sp_3
  const car_all_sp_3 = document.querySelector(".car_car_sp_3")
  if (isArticle4) {
    gsap.timeline({
      scrollTrigger: {
        trigger: car_all_sp_3,
        scrub: 1,
        start: "center center",
        end: "+=2200",
        // markers: true,
      }
    }).to(car_all_sp_3, {
      y: "+=540",
    }).to(car_all_sp_3, {
      rotate: "-=90",
      x: "+=30",
      duration: 0.1
    },"-=0.01").to(car_all_sp_3, {
      x: "+=290",
    }).to(car_all_sp_3, {
      rotate: "+=90",
      y: "+=30",
      duration: 0.1
    },"-=0.01").to(car_all_sp_3, {
      y: "+=600",
    }).to(car_all_sp_3, {
      rotate: "+=90",
      x: "-=60",
      duration: 0.1
    },"-=0.01").to(car_all_sp_3, {
      x: "-=260",
    }).to(car_all_sp_3, {
      rotate: "-=90",
      y: "+=60",
      duration: 0.1
    }).to(car_all_sp_3, {
      y: "+=1400",
    }).to(car_all_sp_3, {
      opacity: "0",
      duration: 0.1,
    },"-=0.1")
  
  } else {
    gsap.timeline({
      scrollTrigger: {
        trigger: car_all_sp_3,
        scrub: 1,
        start: "center center",
        end: "+=2200",
        // markers: true,
      }
    }).to(car_all_sp_3, {
      y: "+=920",
    }).to(car_all_sp_3, {
      rotate: "-=90",
      x: "+=30",
      duration: 0.1
    },"-=0.01").to(car_all_sp_3, {
      x: "+=290",
    }).to(car_all_sp_3, {
      rotate: "+=90",
      y: "+=30",
      duration: 0.1
    },"-=0.01").to(car_all_sp_3, {
      y: "+=520",
    }).to(car_all_sp_3, {
      rotate: "+=90",
      x: "-=60",
      duration: 0.1
    },"-=0.01").to(car_all_sp_3, {
      x: "-=260",
    }).to(car_all_sp_3, {
      rotate: "-=90",
      y: "+=60",
      duration: 0.1
    }).to(car_all_sp_3, {
      y: "+=900",
    }).to(car_all_sp_3, {
      opacity: "0",
      duration: 0.1,
    },"-=0.1") 
  }



  //////////////////// 車_sp_4
  const car_all_sp_4 = document.querySelector(".car_car_sp_4")
  gsap.timeline({
    scrollTrigger: {
      trigger: car_all_sp_4,
      scrub: 1,
      start: "center center",
      end: "+=1800",
      // markers: true,
    }
  }).to(car_all_sp_4, {
    y: "+=660",
  }).to(car_all_sp_4, {
    rotate: "-=90",
    x: "+=30",
    duration: 0.1
  },"-=0.01").to(car_all_sp_4, {
    x: "+=290",
  }).to(car_all_sp_4, {
    rotate: "+=90",
    y: "+=30",
    duration: 0.1
  },"-=0.01").to(car_all_sp_4, {
    y: "+=500",
  }).to(car_all_sp_4, {
    rotate: "+=90",
    x: "-=60",
    duration: 0.1
  },"-=0.01").to(car_all_sp_4, {
    x: "-=250",
  }).to(car_all_sp_4, {
    rotate: "-=90",
    y: "+=60",
    duration: 0.1
  }).to(car_all_sp_4, {
    y: "+=550",
  }).to(car_all_sp_4, {
    opacity: "0",
    duration: 0.1,
  },"-=0.1")
}


//////////////////// 車_vol.06（道路の位置から経路を算出）
if (isArticle6) {
  // 向き（他の記事と同じく90°ずつ回転）：右=0 / 下=90 / 左=180（天地逆）
  const ROT = { right: 0, down: 90, left: 180 };
  let carTimelines6 = [];

  // offsetParent（.guide_article_titles）基準の座標
  const center6 = (el) => ({
    x: el.offsetLeft + el.offsetWidth / 2,
    y: el.offsetTop + el.offsetHeight / 2,
  });
  const bottom6 = (el) => el.offsetTop + el.offsetHeight;
  const q6 = (section, cls) => section.querySelector("." + cls);

  //////// 道路：本文ブロックの実際の位置から、ブロック間の余白の中央に横道路を通す
  // （フォントや画面幅で本文の高さが変わっても道路が本文に被らないように。CSSの値は読込前の初期値）
  const setLine6 = (section, cls, bottom, height) => {
    const el = q6(section, cls);
    if (!el) return;
    el.style.bottom = -bottom + "px";
    if (height !== undefined) el.style.height = Math.max(0, height) + "px";
  };

  const layoutRoads6 = () => {
    document.querySelectorAll(".guide_article_inner").forEach((section) => {
      const titles = section.querySelector(".guide_article_titles");
      const blocks = section.querySelectorAll(".guide_article_text_inner");
      const wide = section.querySelector(".guide_article_yokonaga");
      if (!titles || blocks.length < 3 || !wide) return;
      const base = titles.getBoundingClientRect().bottom;
      // ブロックの上端・下端（はみ出した本文や注釈も含める）
      const extent = (block) => {
        let top = Infinity;
        let bottom = -Infinity;
        [block, ...block.querySelectorAll(".p_inner, p, img, .caption")].forEach((el) => {
          const r = el.getBoundingClientRect();
          if (r.height === 0) return;
          top = Math.min(top, r.top - base);
          bottom = Math.max(bottom, r.bottom - base);
        });
        return { top, bottom };
      };
      const b1 = extent(blocks[0]);
      const b2 = extent(blocks[1]);
      const b3 = extent(blocks[2]);
      const end = wide.getBoundingClientRect().top - base;

      if (q6(section, "car_line_tate_sp") && q6(section, "car_line_tate_sp").offsetParent) {
        // SP（道幅20px・カーブ60px）：r1 / r2 は横道路の下端
        const r1 = Math.round((b1.bottom + b2.top) / 2 + 10);
        const r2 = Math.round((b2.bottom + b3.top) / 2 + 10);
        setLine6(section, "car_line_tate_sp", r1 - 60, r1 - 60);
        setLine6(section, "car_line_curve_sp", r1);
        setLine6(section, "car_line_yoko_sp", r1);
        setLine6(section, "car_line_curve_sp2", r1 + 40);
        setLine6(section, "car_line_tate_sp2", r2 - 60, r2 - r1 - 100);
        setLine6(section, "car_line_curve_sp3", r2);
        setLine6(section, "car_line_yoko_sp2", r2);
        setLine6(section, "car_line_curve_sp4", r2 + 40);
        setLine6(section, "car_line_tate_sp3", end, end - r2 - 40);
      } else if (q6(section, "car_line_tate2") && q6(section, "car_line_tate2").offsetParent) {
        // PC（道幅60px・カーブ180px）：1本目の横道路は写真直下で固定、r2 / r3 は横道路の下端
        const r2 = Math.round((b1.bottom + b2.top) / 2 + 30);
        const r3 = Math.round((b2.bottom + b3.top) / 2 + 30);
        setLine6(section, "car_line_tate2", r2 - 180, r2 - 600);
        setLine6(section, "car_line_curve3", r2);
        setLine6(section, "car_line_yoko2", r2);
        setLine6(section, "car_line_curve4", r2 + 120);
        setLine6(section, "car_line_tate3", r3 - 180, r3 - r2 - 300);
        setLine6(section, "car_line_curve5", r3);
        setLine6(section, "car_line_yoko3", r3);
        setLine6(section, "car_line_curve6", r3 + 120);
        setLine6(section, "car_line_tate4", end, end - r3 - 120);
      }
    });
  };

  //////// 車：道路の中心線に沿った通過点を作り、タイヤが道路に乗るよう車体の「上」方向へずらす
  // points: [{x, y, dir}] / lift: 中心線から車体中心までのずらし量
  // 縦移動はスクロール量と1:1、横移動は1本あたり rowScroll px のスクロールで走り切る
  // （横移動の分だけ車が画面上へずれていくので、開始位置を画面下寄り startAt にしておく）
  // 角の90°回転は他の記事と同様に短く（turnScroll px のスクロール）で曲がり切る
  const buildCar6 = (car, trigger, points, lift, rowScroll, turnScroll, startAt) => {
    const home = center6(car);
    const pos = (p) => {
      const rad = (ROT[p.dir] * Math.PI) / 180;
      return {
        x: p.x + Math.sin(rad) * lift - home.x,
        y: p.y - Math.cos(rad) * lift - home.y,
        rotation: ROT[p.dir],
      };
    };
    gsap.set(car, { ...pos(points[0]), scaleX: 1, opacity: 1, transformOrigin: "50% 50%" });
    const xs = points.map((p) => p.x);
    const rowWidth = Math.max(...xs) - Math.min(...xs) || 1;
    const durations = [];
    for (let i = 1; i < points.length; i++) {
      const dx = Math.abs(points[i].x - points[i - 1].x);
      const dy = Math.abs(points[i].y - points[i - 1].y);
      const turning = points[i].dir !== points[i - 1].dir;
      durations.push(turning ? turnScroll : dy + (rowScroll * dx) / rowWidth);
    }
    const total = durations.reduce((a, b) => a + b, 0);
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: trigger,
        scrub: 1,
        start: "top+=" + points[0].y + " " + startAt,
        end: "+=" + total,
        invalidateOnRefresh: true,
      },
    });
    for (let i = 1; i < points.length; i++) {
      tl.to(car, { ...pos(points[i]), duration: durations[i - 1] / 100, ease: "none" });
    }
    tl.to(car, { opacity: 0, duration: 0.3 }, "-=0.3");
    carTimelines6.push(tl);
  };

  // タイヤ（車体下側）が道幅の中に収まるずらし量
  const lift6 = (car, roadWidth) => car.offsetHeight / 2 - roadWidth * 0.3;

  const setupCars6 = () => {
    carTimelines6.forEach((tl) => {
      if (tl.scrollTrigger) tl.scrollTrigger.kill();
      tl.kill();
    });
    carTimelines6 = [];

    document.querySelectorAll(".guide_article_inner").forEach((section) => {
      const titles = section.querySelector(".guide_article_titles");
      if (!titles) return;

      // PC：横道路①（右へ）→ 右の縦道路 → 横道路②（左へ）→ 左の縦道路 → 横道路③（右へ）→ 右の縦道路 → 終点
      const car = q6(section, "car_car");
      if (car && car.offsetParent) {
        const tate = q6(section, "car_line_tate");
        const L = center6(tate).x;
        const R = center6(q6(section, "car_line_tate2")).x;
        const y1 = center6(q6(section, "car_line_yoko")).y;
        const y2 = center6(q6(section, "car_line_yoko2")).y;
        const y3 = center6(q6(section, "car_line_yoko3")).y;
        const end = bottom6(q6(section, "car_line_tate4"));
        const curve = q6(section, "car_line_curve");
        const r = 150; // カーブ（180px・道幅60px）の中心線の半径
        const half = car.offsetWidth / 2;
        buildCar6(car, titles, [
          { x: curve.offsetLeft + curve.offsetWidth + half, y: y1, dir: "right" },
          { x: R - r, y: y1, dir: "right" },
          { x: R, y: y1 + r, dir: "down" },
          { x: R, y: y2 - r, dir: "down" },
          { x: R - r, y: y2, dir: "left" },
          { x: L + r, y: y2, dir: "left" },
          { x: L, y: y2 + r, dir: "down" },
          { x: L, y: y3 - r, dir: "down" },
          { x: L + r, y: y3, dir: "right" },
          { x: R - r, y: y3, dir: "right" },
          { x: R, y: y3 + r, dir: "down" },
          { x: R, y: end - half, dir: "down" },
        ], lift6(car, tate.offsetWidth), 200, 40, "65%");
      }

      // SP：左の縦道路 → 横道路①（右へ）→ 右の縦道路 → 横道路②（左へ）→ 左の縦道路 → 終点
      const carSp = q6(section, "car_car_sp");
      if (carSp && carSp.offsetParent) {
        const tateSp = q6(section, "car_line_tate_sp");
        const L = center6(tateSp).x;
        const R = center6(q6(section, "car_line_tate_sp2")).x;
        const y1 = center6(q6(section, "car_line_yoko_sp")).y;
        const y2 = center6(q6(section, "car_line_yoko_sp2")).y;
        const end = bottom6(q6(section, "car_line_tate_sp3"));
        const r = 50; // カーブ（60px・道幅20px）の中心線の半径
        const half = carSp.offsetWidth / 2;
        buildCar6(carSp, titles, [
          { x: L, y: tateSp.offsetTop + half + 10, dir: "down" },
          { x: L, y: y1 - r, dir: "down" },
          { x: L + r, y: y1, dir: "right" },
          { x: R - r, y: y1, dir: "right" },
          { x: R, y: y1 + r, dir: "down" },
          { x: R, y: y2 - r, dir: "down" },
          { x: R - r, y: y2, dir: "left" },
          { x: L + r, y: y2, dir: "left" },
          { x: L, y: y2 + r, dir: "down" },
          { x: L, y: end - half, dir: "down" },
        ], lift6(carSp, tateSp.offsetWidth), 150, 20, "60%");
      }
    });
    ScrollTrigger.refresh();
  };

  const setup6 = () => {
    layoutRoads6();
    setupCars6();
  };

  // 画像・フォント読込後に位置が確定するので load / フォント読込完了で作成し、リサイズ時は作り直す
  window.addEventListener("load", () => {
    setup6();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(setup6);
  });
  // スマホはスクロール中のアドレスバー伸縮でも resize が起きるので、横幅が変わった時だけ作り直す
  let resizeTimer6;
  let lastWidth6 = window.innerWidth;
  window.addEventListener("resize", () => {
    if (window.innerWidth === lastWidth6) return;
    lastWidth6 = window.innerWidth;
    clearTimeout(resizeTimer6);
    resizeTimer6 = setTimeout(setup6, 300);
  });
}
